/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment-modal.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { SetDashboardModalShownRequest } from '@square/dashboard-protos/models/squareup/jpsmirf/externalservice';
import JpSmirfService from '@dashboard/shared-ui/clients/jpsmirf';
import { inject as service } from '@ember/service';
import { getFormattedCpRate } from '@dashboard/shared-ui/utils/jp-smirf';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
let JpSmirfEnrollmentModal = (_class = class JpSmirfEnrollmentModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "cpFeeRate", _descriptor2, this);
    JpSmirfService.setDashboardModalShown(SetDashboardModalShownRequest.create({}));
  }
  get checkEligibilityLink() {
    return '/dashboard/account/jp-smirf-enrollment';
  }

  // By default, the rate offered by the SMIRF program is 2.5% for in-person transactions.
  // If the merchant is in a P&P experiment, the rate offered to them would be included in
  // the modalData, and we would use that rate instead as it would replace the default 2.5% rate.
  get isInPnpExperiment() {
    return this.cpFeeRate?.cpBasisPoints;
  }
  get titleText() {
    if (this.isInPnpExperiment) {
      return htmlSafe(this.intl.t('jpsmirf.enrollmentModal.titlePnp'));
    }
    return htmlSafe(this.intl.t('jpsmirf.enrollmentModal.title'));
  }
  get text() {
    if (this.isInPnpExperiment) {
      return htmlSafe(this.intl.t('jpsmirf.enrollmentModal.textPnp', {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cpRate: getFormattedCpRate(this.intl, this.cpFeeRate)
      }));
    }
    return htmlSafe(this.intl.t('jpsmirf.enrollmentModal.textV2'));
  }
  get modalAssetPath() {
    if (this.isInPnpExperiment) {
      if (this.cpFeeRate?.cpBasisPoints === 180 && this.cpFeeRate?.cpInterchangeCents === 80) {
        return '/@dashboard/shared-ui/images/intl/jp-smirf-modal-180-80.png';
      }

      // Generic image for all other P&P rates
      return '/@dashboard/shared-ui/images/intl/jp-smirf-modal-generic.png';
    }

    // Standard SMIRF rates (2.5%)
    return '/@dashboard/shared-ui/images/intl/jp-smirf-modal-v2.png';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cpFeeRate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalData?.cpFeeRate;
  }
}), _class);
export { JpSmirfEnrollmentModal as default };